var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGbiArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 5 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 5,
    height: 6,
    fill: "none",
    customFrame: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u591A\\u8FB9\\u5F62 1",
    d: "M3.42875 0.714577L5.54565 4.24275C5.74561 4.57601 5.50555 5 5.1169 5L0.883095 5C0.494448 5 0.254391 4.57601 0.454349 4.24275L2.57125 0.714577C2.76546 0.390908 3.23454 0.390908 3.42875 0.714577Z",
    fill: "rgb(67,108,250)",
    fillRule: "evenodd",
    transform: "matrix(0,1,-1,0,5,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u591A\\u8FB9\\u5F62 1",
    d: "M3.42875 0.714577L5.54565 4.24275C5.59514 4.32524 5.61768 4.41328 5.61768 4.49907C5.61768 4.75992 5.40936 5 5.1169 5L0.883095 5C0.590639 5 0.382323 4.75992 0.382323 4.49907C0.382323 4.41328 0.404859 4.32524 0.454349 4.24275L2.57125 0.714577C2.76546 0.390908 3.23454 0.390908 3.42875 0.714577ZM3 1.94365L1.76619 4L4.23381 4L3 1.94365Z",
    fill: "rgb(112,112,112)",
    fillOpacity: 0,
    fillRule: "evenodd",
    transform: "matrix(0,1,-1,0,5,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbiArrow);
export default __webpack_public_path__ + "static/media/gbiArrow.95d7877449bd792f140458233eea3528.svg";
export { ForwardRef as ReactComponent };